import { usePost, UsePostParams } from '../../../../api';
import { useCallback } from 'react';
import { USER_MANAGEMENT_BASE_URL } from '../consts';
import { User } from '../../types/User';

interface MatchUsersPayload {
    primaryUserGuid: User['guid'];
    secondaryUsersGuids: User['guid'][];
}

type MatchUsersResponse = MatchUsersPayload;

interface MatchUsersErrorResponse {
    error: string;
}

export type UseMatchUsersParams = UsePostParams<MatchUsersPayload, MatchUsersResponse, MatchUsersErrorResponse>;

export const useMatchUsers = (params: UseMatchUsersParams) => {
    const { post, ...rest } = usePost(params);

    const matchUsers = useCallback(
        (primaryUserGuid: User['guid'], secondaryUsersGuids: User['guid'][]) =>
            post(`${USER_MANAGEMENT_BASE_URL}/matchUsers`, {
                primaryUserGuid,
                secondaryUsersGuids
            }),
        [post]
    );

    return {
        ...rest,
        matchUsers
    };
};
